export const SCORE = 'score';
export const RESET_SCORE = 'reset-score';
export const BEST_SCORE = 'best-score';
export const ADDITION = 'addition';
export const ADDITION_OUT = 'addition-out';
export const GAME_OVER = 'game-over';
export const GAME_WON = 'game-won';
export const KEEP_PLAYING_GAME = 'keep-playing-game';


// WEBPACK FOOTER //
// ./src/actions/index.jsx